import CommercialRealEstate from "./CommercialRealEstate";
import AccessoriesAndFixedFittings from "../accessoriesAndFixedFittings/AccessoriesAndFixedFittings";
import { Fragment } from "react";
function ParentCommercialRealEstate(props={}) {
  return (
    <Fragment>
      {/*<GeneralNonResidential parentComponent='parentCommercialRealEstate' disabled={props.preview}/>*/}
      <CommercialRealEstate disabled={props.preview}/>
      <AccessoriesAndFixedFittings parentComponent='parentCommercialRealEstate' component='mainData' disabled={props.preview}/>
    </Fragment>
    );
};

export default ParentCommercialRealEstate;